export default `$ curl 'localhost:9292/run/Add?operand1=5&operand2=6'
11`
